module.exports = __webpack_public_path__ + "media/images/noticias/viejas/mamo-digital-90ae7af7f7bbef71a38ef7f40c9f6713.jpg";